module.exports = __webpack_public_path__ + "media/images/flags/re-49693a5fe906f406fc1d6d7745183582.svg";